import {walletSvg as Icon__small__walletSvg} from '../Icon__small/Icon__small--wallet.js'

export var wallet = {
  name: 'wallet',
  category: 'icon',
  colorable: true,
  svg: Icon__small__walletSvg,
};
